<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
            <el-breadcrumb-item>角色列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="6">
                    <el-input placeholder="请输入角色名称" v-model="queryInfo.roleName" clearable @clear="getRoleList()">
                    </el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="el-icon-search" @click="getRoleList()">{{$t('common.search')}}</el-button>
                </el-col>
                <!--添加区域-->
                <el-col :span="2">
                    <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">添加角色</el-button>
                </el-col>
            </el-row>
            <!--角色列表区域-->
            <el-table :data="roleList.records" border stripe v-loading="tableLoading">
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column label="名称" prop="roleName"></el-table-column>
                <el-table-column label="创建时间" prop="createTime"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <!--修改-->
                        <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
                            <el-button type="primary" icon="el-icon-edit" size="mini"
                                       @click="showEditDialog(scope.row)"></el-button>
                        </el-tooltip>
                        <!--删除-->
                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeById(scope.row)"></el-button>
                        </el-tooltip>
                        <!--分配权限-->
                        <el-tooltip effect="dark" content="授权" placement="top" :enterable="false">
                            <el-button type="primary" icon="el-icon-setting" size="mini"
                                       @click="showDialog(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="roleList.total">
            </el-pagination>
        </el-card>
        <!--添加角色的对话框-->
        <el-dialog
                title="添加角色"
                :visible.sync="addDialogVisible"
                width="50%"
                @close="addDialogClosed">
            <!--内容主体区域-->
            <el-form :model="addRoleForm" :rules="addRoleRules" ref="addRoleRef" label-width="70px">
                <el-form-item label="名称" prop="roleName">
                    <el-input v-model="addRoleForm.roleName"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-select v-model="addRoleForm.state" placeholder="请选择">
                        <el-option v-for="(item,index) in options"
                                   :key="index"
                                   :value="item.value"
                                   :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="addDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="addRole">确 定</el-button>
  </span>
        </el-dialog>
        <!--修改角色的对话框-->
        <el-dialog
                title="修改角色"
                :visible.sync="editDialogVisible"
                width="50%">
            <!--内容主体区域-->
            <el-form :model="editRoleForm" :rules="addRoleRules" ref="addRoleRef" label-width="70px">
                <el-form-item label="名称" prop="roleName">
                    <el-input v-model="editRoleForm.roleName"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-select v-model="editRoleForm.state" placeholder="请选择">
                        <el-option v-for="(item,index) in options"
                                   :key="index"
                                   :value="item.value"
                                   :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="editRoleInfo">确 定</el-button>
  </span>
        </el-dialog>
        <el-dialog
                title="功能授权"
                :visible.sync="DialogVisible"
                width="50%">
            <!--内容主体区域-->
            <div>
                <el-collapse>
                    <el-collapse-item :title="item.authorityName" :name="index" v-for="(item,index) in menuList"
                                      :key="index">
                        <el-checkbox-group v-model="checkList" @change="checkMenuChange">
                            <el-checkbox :label="authItem.id" v-for="(authItem,authIndex) in item.children"
                                         :key="authIndex">{{authItem.authorityName}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addRoleInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "RoleList",
        data() {
            return {
                checkList: [],
                roleUuid: '',
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10
                },
                roleList: {
                    records: [],
                    total: 0
                },
                // 控制添加角色弹框的显示和隐藏
                addDialogVisible: false,
                // 控制修改角色对话框的显示与隐藏
                editDialogVisible: false,
                DialogVisible: false,
                // 添加的角色对象
                addRoleForm: {
                    state: 1
                },
                // 修改的角色对象
                editRoleForm: {},
                // 添加角色的验证规则
                addRoleRules: {
                    roleName: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur'}
                    ],
                    state: [
                        {required: true, message: '请输入状态', trigger: 'blur'}
                    ]
                },
                options: [
                    {label: '有效', value: 1},
                    {label: '无效', value: 0}
                ],
                tableLoading: false,
                menuList: []
            }
        },
        created() {
            this.getRoleList();
            this.getAllMenus()
        },
        methods: {
            // 选中修改
            checkMenuChange(val) {
                console.log(val)
                this.checkList = val;
            },
            async getRoleList() {
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/api/role/selectPage`, this.queryInfo);
                this.tableLoading = false
                if (res.code !== 1) return this.$message.error("获取角色列表失败！");
                this.roleList.total = res.data.total;
                this.roleList.records = res.data.records;
            },

            async getAllMenus() {
                let {data: res} = await this.$http.post(`/api/menuInfo/getAllMenus`, {});
                if (res.code !== 1) return this.$message.error("获取角色列表失败！");
                this.menuList = res.data
                console.log(this.menuList)
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getRoleList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getRoleList()
            },
            async stateChange(info) {
                let {data: res} = await this.$http.post(`/api/role/saveOrUpdate`, info);
                if (res.code !== 1) {
                    info.state = !info.state;
                    return this.$message.error(res.msg)
                }
                this.$message.success("更新状态成功")
            },
            // 监听添加角色对话框的关闭事件
            addDialogClosed() {
                this.$refs['addRoleRef'].resetFields();
            },
            // 点击按钮添加新角色
            addRole() {
                this.$refs.addRoleRef.validate(async valid => {
                    if (!valid) return;
                    // 发起添加角色的网络请求
                    const {data: res} = await this.$http.post('/api/role/saveOrUpdate', this.addRoleForm);
                    if (res.code !== 1) return this.$message.error(res.data);
                    this.$message.success("添加角色成功");
                    // 隐藏添加角色对话框
                    this.addDialogVisible = false;
                    // 重新获取角色列表
                    this.getRoleList();
                })
            },
            // 展示修改角色的对话框
            async showEditDialog(role) {
                const {data: res} = await this.$http.post(`/api/role/getById`, role);
                if (res.code !== 1) return this.$message.error("查询角色失败");
                this.editRoleForm = res.data;
                this.editDialogVisible = true;
            },
            //展示功能授权对话框
            async showDialog(role) {
                this.checkList = [];
                this.roleUuid = role.roleUuid
                const {data: res} = await this.$http.post(`/api/menuInfo/getMenuByPermissionInfo`, role);
                if (res.code !== 1) return this.$message.error("查询功能失败");
                this.checkList = res.data
                this.DialogVisible = true;
            },
            // 展示添加角色的对话框
            async showAddDialog() {
                this.addDialogVisible = true;
            },
            // 修改角色信息并提交
            editRoleInfo() {
                this.$refs.addRoleRef.validate(async valid => {
                    if (!valid) return;
                    // 发起修改角色的网络请求
                    const {data: res} = await this.$http.post(`/api/role/saveOrUpdate`, this.editRoleForm);
                    if (res.code !== 1) return this.$message.error(res.msg);
                    this.$message.success("修改角色成功");
                    // 重新获取角色列表
                    this.getRoleList();
                    // 隐藏添加角色对话框
                    this.editDialogVisible = false;
                })
            },
            async addRoleInfo() {
                // 发起权限网络请求
                const {data: res} = await this.$http.post(`/api/menuInfo/addMenuByPermissionInfo`, {
                    checkList: this.checkList,
                    roleUuid: this.roleUuid
                });
                if (res.code !== 1) return this.$message.error(res.msg);
                this.$message.success("修改权限成功");
                // 重新获取角色列表
                this.getRoleList();
                // 隐藏添加角色对话框
                this.DialogVisible = false;

            },
            // 根据id删除角色信息
            async removeById(role) {
                // 弹框询问用户是否删除角色
                await this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除角色
                    const {data: res} = await this.$http.post(`/api/role/removeById`, role);
                    if (res.code !== 1) return this.$message.error("删除角色失败");
                    this.$message.success("删除角色成功");
                    // 重新获取角色列表
                    this.getRoleList();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
<style>
    .el-collapse-item__content {
        height: 48px;
        padding-left: 40px;
        padding-bottom: 0px !important;
        line-height: 48px !important;
        background-color: #dddddd !important;
    }

    .el-collapse-item__header {
        padding-left: 20px;
        background-color: #efefef !important;
    }
</style>

